// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"219f3341","484":"97e1590d","624":"df99374e","799":"070a57b5","893":"3b9001db"}[chunkId] + ".chunk.js";
};